import { z } from 'zod';

export const llmConfigSchema = z.object({
  serviceId: z.string().min(1, 'Service ID is required'),
  providerType: z.enum(['openai', 'anthropic', 'gemini', 'azure-openai']),
  apiKey: z.string().optional().or(z.literal('')),
  modelName: z.string().min(1, 'Model name is required'),
  baseEndpointUrl: z.string().url().optional().or(z.literal('')),
  defaultSystemPrompt: z.string().optional(),
  maxTokenLimit: z.number().int().positive('Must be a positive integer'),
  temperature: z.number().min(0, 'Min 0.0').max(2, 'Max 2.0'),
});

/** Schema for create mode where API key is required */
export const llmConfigCreateSchema = llmConfigSchema.extend({
  apiKey: z.string().min(1, 'API Key is required'),
});

export type LlmConfigFormData = z.infer<typeof llmConfigSchema>;
